import { ArrowRight } from 'lucide-react';

export const VoicePipelineFunnel = ({ stages }) => (
  <section className="space-y-4" data-testid="voice-pipeline-funnel">
    <div>
      <p className="text-xs font-semibold uppercase text-[#8B7355]">Success funnel</p>
      <h2 className="mt-1 font-serif text-2xl text-[#1A1A1A]">Where conversations make it through</h2>
    </div>
    <div className="overflow-x-auto pb-3">
      <div className="flex min-w-max items-stretch gap-2">
        {stages.map((stage, index) => {
          const thresholdBreached = stage.attempts >= 3 && stage.failure_rate >= 10;
          return (
            <div className="flex items-center gap-2" key={stage.id}>
              <div
                className="w-36 border bg-white p-4 rounded-md animate-message-in"
                style={{ borderColor: thresholdBreached ? '#C85A3C' : '#EAE5D9', animationDelay: `${index * 0.05}s` }}
                data-testid={`voice-stage-${stage.id}`}
              >
                <p className="text-xs font-semibold uppercase text-[#8A8A8A]">{stage.label}</p>
                <p className="mt-3 font-serif text-3xl" style={{ color: thresholdBreached ? '#C85A3C' : '#1E3F33' }}>
                  {stage.attempts ? `${stage.success_rate}%` : '—'}
                </p>
                <p className="mt-1 text-xs text-[#5C5C5C]">{stage.successes} of {stage.attempts}</p>
                {thresholdBreached && <p className="mt-2 text-xs font-semibold text-[#C85A3C]">{stage.failure_rate}% failed</p>}
              </div>
              {index < stages.length - 1 && (
                <div className="flex flex-col items-center gap-1 text-[#B8B0A1]">
                  <ArrowRight className="h-4 w-4" />
                  {stage.dropoff_rate > 0 && <span className="text-[10px] text-[#C85A3C]">-{stage.dropoff_rate}%</span>}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  </section>
);
